import template from './index.pug'

export default {

  template: template(),

  name: "PhotoUploader",
  props: {
    id: {
      type: String,
      default: "photo-uploader",
    },
    value: {
      type: [File, String ],
      default: null,
    },
  },
  data() {
    return {
      preview: null, // Para mostrar la vista previa de la imagen
      fileName: '',
      errorMessage:''
    };
  },
  methods: {
    onFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.errorMessage = '';

        if (!this.validateFile(file)) {
          this.resetFileInput(); // Resetea el input si el archivo no es válido
          return;
        }

        this.fileName = file.name;
        this.preview = URL.createObjectURL(file); // Genera la vista previa
        this.$emit("input", file); // Emite el archivo seleccionado al componente padre
      }
    },
    triggerFileInput() {
      // Dispara el clic en el input oculto
      this.$refs.fileInput.click();
    },
    validateFile(file) {
      const maxSizeInMB = 5;
      const allowedFormats = ["image/jpeg", "image/png"];
  
      // Validar el tamaño del archivo (máximo 5 MB)
      if (file.size > maxSizeInMB * 1024 * 1024) {
        this.errorMessage = "El tamaño máximo permitido es de 5 MB.";
        return false;
      }
  
      // Validar el formato del archivo (JPG o PNG)
      if (!allowedFormats.includes(file.type)) {
        this.errorMessage = "Solo se permiten imágenes en formato JPG o PNG.";
        return false;
      }
  
      return true; // El archivo es válido
    },

    resetFileInput() {
      // Resetea el input de archivo
      this.$refs.fileInput.value = null;
      this.fileName = '';
      this.preview = null;
    }
  }
};